module.exports = __webpack_public_path__ + "img/splogo.00f2cef8.png";